<template>
	<div id="new-event">
      <form-event editingMode="create"></form-event>
    <br/>
	</div>
</template>

<script>
import api from "../../api"
import formEvent from './formEvent'
export default {
	name: "newEvent",
  components: {
    formEvent
  }
}
</script>

<style lang='css'>
#new-event {
	color: #53574D
}
</style>
